import '.fz{justify-content:flex-start;}.ssr-plugin'
import '.t{align-items:center;}.ssr-plugin'
import '.c6{display:inline-flex;}.ssr-plugin'
import '.gp{overflow-x:auto;}.ssr-plugin'
import '.co{scrollbar-width:none;}.ssr-plugin'
import '.dp{user-select:none;}.ssr-plugin'
import '.gq{scroll-margin-top:var(--header-height);}.ssr-plugin'
import { useRef, useEffect, type ReactNode } from 'react'
import { styled, type Style } from 'inlines'
import { TabsContext } from './TabsContext'

export type TabRowProps = {
  selectedTab: string
  style?: Style
  children: ReactNode
}

export const TabRow = ({ selectedTab, style, children }: TabRowProps) => {
  const groupRef = useRef<HTMLDivElement>(null)
  const isFirstRender = useRef(true)

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false
      return
    }

    const el = groupRef.current
    if (!el) {
      return
    }

    const headerHeightValue = getComputedStyle(document.documentElement)
      .getPropertyValue('--header-height')
      .trim()
    const headerHeight = headerHeightValue ? parseFloat(headerHeightValue) : 0

    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0]
        if (entry && !entry.isIntersecting) {
          el.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
            inline: 'nearest',
          })
        }
        observer.disconnect()
      },
      { rootMargin: `-${headerHeight}px 0px 0px 0px` },
    )

    observer.observe(el)

    return () => observer.disconnect()
  }, [selectedTab])

  return (
    <TabsContext.Provider value={{ selectedTab }}>
      <styled.div className="fz t c6 gp co dp gq"
        ref={groupRef}
        style={{
          ...style,
        }}
      >
        {children}
      </styled.div>
    </TabsContext.Provider>
  )
}
